import styled from "@emotion/styled";
import {ReactComponent as airSvg} from "../../../../../../images/iconMap.svg";

export const MapSvg = styled(airSvg)`
    padding: 0;
    overflow: visible;
`;